import config from '@/config';
import { joinBaseUrl } from '@/shared/utils/url';

export const FRONTEND_ROUTES = {
	HOME: '/',
};

export const ROUTES_API = {
	QUESTION_ANSWER: '/api/question-answer',
	GET_USER_DATA: '/api/get-user-data',
	SEND_EVENT: '/api/send-event',
	INVALIDATE_TOKEN: '/api/invalidate-token',
	OAUTH2_TOKEN: '/oauth2/token',
};

export const getAudioPath = (lang: string, word: string) => {
	const params = new URLSearchParams({
		lang,
		word,
	});

	return `${joinBaseUrl(config.speak_api_url, '/external_services/speak')}?${params.toString()}`;
};

export const getUpdateUserPath = (userId: string | number) => {
	return `/api/users/${userId}`;
};
